let state = {
  // 国家前缀列表
  prefixData: [
    {name: '中国大陆', value: '86', text: '+86'},
    {name: '中国香港', value: '852', text: '+852'},
    {name: '中国澳门', value: '853', text: '+853'},
    {name: '中国台湾', value: '886', text: '+886'},
    {name: '新加坡', value: '65', text: '+65'},
    {name: '美国', value: '1', text: '+1'},
    {name: '加拿大', value: '1', text: '+1'},
    {name: '英国', value: '44', text: '+44'},
    {name: '荷兰', value: '31', text: '+31'},
    {name: '德国', value: '49', text: '+49'},
    {name: '挪威', value: '47', text: '+47'},
    {name: '丹麦', value: '45', text: '+45'},
    {name: '法国', value: '33', text: '+33'},
    {name: '爱尔兰', value: '353', text: '+353'},
    {name: '瑞典', value: '46', text: '+46'},
    {name: '瑞士', value: '41', text: '+41'},
    {name: '西班牙', value: '34', text: '+34'},
    {name: '意大利', value: '39', text: '+39'},
    {name: '奥地利', value: '43', text: '+43'},
    {name: '俄罗斯', value: '7', text: '+7'},
    {name: '新西兰', value: '64', text: '+64'},
    {name: '澳大利亚', value: '61', text: '+61'},
    {name: '日本', value: '81', text: '+81'},
    {name: '芬兰', value: '358', text: '+358'},
    {name: '匈牙利', value: '36', text: '+36'},
    {name: '泰国', value: '66', text: '+66'},
    {name: '韩国', value: '82', text: '+82'},
  ],
  // oss上传
  uploadParams: {
    host: '',
    policyBase64: '',
    accessid: '',
    signature: '',
    expire: '',
    callback: '',
    key: '',
  },
  // 菜单当前项
  currentMenu: 'index',
  // 当前设备是否是刘海屏
  isIPhoneX: false,
  // 当前页面的模块名
  currentPage: '首页',
}

export default state;



// WEBPACK FOOTER //
// ./src/vuex/state.js